import React from 'react';
import ReactDOM from 'react-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/jquery/dist/jquery.min.js';
// import '../node_modules/get-google-fonts/fonts/fonts.css';
// import '../node_modules/aos/dist/aos.css';
// import '../node_modules/aos/dist/aos.js';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import './css/fontawesome-free-5.11.2-web/css/all.css'
import './index.css';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import RouterWithTracking from './RouterWithTracking.js';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: "GTM-KZ58HLS",
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    (<Router basename={process.env.REACT_APP_ROUTER_BASE || ''}>
        <RouterWithTracking />
    </Router>), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
